<script>
import Banner from "@/components/atoms/Banner";
import Btn from "@/components/atoms/Btn";
export default {
  components: { Banner, Btn },
  data(){
    return {
      glb_url: null
    }
  },
  mounted(){
    console.log(this.$route.params.uid);
    console.log(this.$route.params.glb);
    this.$store.dispatch("saveFiles/getPublicGlb", {uid: this.$route.params.uid, name: this.$route.params.glb}).then(url => {
      console.log(url)
      this.glb_url = url
    });
  },
  methods: {
    nonMobileARView(){
      this.$toast("Augmented reality is only available on mobile devices.", {
        type: "success",
      });
    }
  }
}
</script>

<template>
  <div id="viewer-page" v-if="glb_url">
    <model-viewer id="static-model" alt="Quadrobee Project" :src="glb_url" ar shadow-intensity="1" camera-controls >
      <btn slot="ar-button" class="ar-view" size="medium" type="fill" color="secondary"><span class="fa fa-vr-cardboard"></span>AR</btn>
      <btn v-if="!$store.get('usingMobile')" class="ar-view" size="medium" type="fill" color="secondary" @click="nonMobileARView"><span class="fa fa-vr-cardboard"></span>AR</btn>
    </model-viewer>
    <img src="@/assets/Quadrobee.svg" />
  </div>
</template>

<style lang="scss">
@import "~@/styles/constants";
#viewer-page{
  model-viewer{
    width: 100dvw;
    height: 100dvh;
    position: fixed;
    top: 0rem;
    left: 0rem;
    .ar-view{
      position: absolute;
      bottom: 1.5rem;
      right: 1.5rem;
    }
  }
  img{
    position: fixed;
    top: 1rem;
    left: 1rem;
    width: 8rem;
    opacity: 0.5;
  }
}
</style>